import React, { useState, useContext, useEffect } from "react";
import PriceTableRow from "./priceTableRow/PriceTableRow.jsx";
import ValueTable from "./valueTable/valueTable.jsx";
import Form from "react-bootstrap/Form";
import { Button, Table, Container, Row, Col } from "react-bootstrap";
import { PlusCircle } from "react-bootstrap-icons";
import productionSheetContext from "../../../store/productionSheetContext";
import Card from "react-bootstrap/Card";
import { InputGroup } from "react-bootstrap";

const PriceTable = () => {
  const {
    costs,
    setCosts,
    profit,
    setProfit,
    currency,
    setCurrency,
    notes,
    setNotes,
  } = useContext(productionSheetContext);
  const [newCostLabel, setNewCostLabel] = useState("");

  const addCost = () => {
    const newCost = {
      label: newCostLabel || "New Cost",
      costPrice: 1,
      unit: "1",
    };
    setCosts((prevData) => [...prevData, newCost]);
    setNewCostLabel("");
  };

  const { profitUnit, profitAmount, commissionUnit, commissionAmount } =
    profit || {};

  const handleAmount = (e) => {
    const { name, value } = e.target;
    setProfit((prev) => ({
      ...prev,
      [name]: isNaN(parseFloat(value)) ? 0 : parseFloat(value),
    }));
  };

  const handleSelect = (e) => {
    const { name, value } = e.target;
    setProfit((prev) => ({ ...prev, [name]: value }));
  };

  const handleNotesChange = (e) => {
    const { value, name } = e.target;

    if (value.length <= 200) {
      setNotes((prevNotes) => ({
        ...prevNotes,
        [name]: value,
      }));
    }
  };

  const handleChangeCurrency = (e) => {
    const { value } = e.target;

    setCurrency(value);
  };

  return (
    <>
      {/* Tabella Costi */}

          <Row>
            <Col xs={12} lg ={4}>
      <Card className={"mb-3"}>
        <Card.Body>
              <InputGroup
                controlId="currency"
                className={"mb-2 d-flex align-items-center"}
              >
                <Form.Label className={"w-50"}>Currency</Form.Label>
                <Form.Select
                  aria-label="Select currency"
                  name="currency"
                  value={currency}
                  onChange={handleChangeCurrency}
                >
                  <option>Select currency</option>
                  <option value="€">EUR - €</option>
                  <option value="$">USD - $</option>
                  <option value="£">GBP - £</option>
                  <option value="¥">JPY - ¥</option>
                  <option value="CN¥">CNY - ¥ (Renminbi)</option>
                  <option value="CHF">CHF - CHF</option>
                  <option value="A$">AUD - A$</option>
                  <option value="C$">CAD - C$</option>
                  <option value="NZ$">NZD - NZ$</option>
                  <option value="MX$">MXN - MX$</option>
                </Form.Select>
              </InputGroup>
        </Card.Body>
      </Card>
            </Col>
          </Row>
      <Card className={"mb-5"}>
        <Card.Header>
          <Card.Title>Costs</Card.Title>
        </Card.Header>
        <Card.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Cost</th>
                <th>Based on</th>
                <th>Value</th>
                <th>Cost</th>
                <th>Total Cost</th>
              </tr>
            </thead>
            <tbody>
              {costs.map((cost, index) => (
                <PriceTableRow
                  costLabel={cost.label}
                  costName={cost.cost_id}
                  key={cost.cost_id || index} // Usa index come fallback per evitare errori
                  index={index}
                  currency={currency}
                  setCosts={setCosts}
                  profit={profit}
                />
              ))}
              <tr>
                <td colSpan={7}>
                  <Form.Control
                    type="text"
                    placeholder="Enter cost"
                    value={newCostLabel}
                    onChange={(e) => setNewCostLabel(e.target.value)}
                  />
                </td>
                <td colSpan={3}>
                  <Button
                    variant="success"
                    onClick={addCost}
                    disabled={newCostLabel === ""}
                  >
                    <PlusCircle size={20} /> Add Cost
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <hr />
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              maxLength={200}
              placeholder="Max 200 characters"
              name="costsNotes"
              value={notes?.costsNotes || ""}
              onChange={handleNotesChange}
            />
            <Form.Text muted>
              {200 - (notes?.costsNotes?.length || 0)} characters left
            </Form.Text>
          </Form.Group>
        </Card.Body>
      </Card>

      <Card className={"mb-5"}>
        <Card.Header>
          <Card.Title>Profit and commissions</Card.Title>
        </Card.Header>
        <Card.Body>
          {/* Tabella Profitto e Commissioni */}
          <Table bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {/* RIGA PROFITTO */}
              <tr>
                <td>Profit</td>
                <td>
                  <Form.Select
                    name="profitUnit"
                    value={profitUnit}
                    onChange={handleSelect}
                  >
                    <option value="1">Select</option>
                    <option value="2">Profit Amount</option>
                    <option value="3">% Markup</option>
                    <option value="4">% Margin</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="profitAmount"
                    placeholder="Profit amount"
                    value={profitAmount}
                    onChange={handleAmount}
                  />
                </td>
              </tr>

              {/* RIGA COMMISSIONI */}
              <tr>
                <td>Commissions</td>
                <td>
                  <Form.Select
                    name="commissionUnit"
                    value={commissionUnit}
                    onChange={handleSelect}
                  >
                    <option value="1">Select</option>
                    <option value="2">Commission Amount</option>
                    <option value="3">% Commission</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="commissionAmount"
                    placeholder="Commission Amount"
                    value={commissionAmount}
                    onChange={handleAmount}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <hr />
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              maxLength={200}
              placeholder="Max 200 characters"
              name="profitNotes"
              value={notes?.profitNotes || ""}
              onChange={handleNotesChange}
            />
            <Form.Text muted>
              {200 - (notes?.profitNotes?.length || 0)} characters left
            </Form.Text>
          </Form.Group>
        </Card.Body>
      </Card>
      <Card className={"mb-5"}>
        <Card.Header>
          <Card.Title>Costs Table</Card.Title>
        </Card.Header>
        <Card.Body>
          {/* Tabella Valori Finali */}
          <ValueTable />
          <hr />
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              maxLength={200}
              placeholder="Max 200 characters"
              name="costsTableNotes"
              value={notes?.costsTableNotes || ""}
              onChange={handleNotesChange}
            />
            <Form.Text muted>
              {200 - (notes?.costsTableNotes?.length || 0)} characters left
            </Form.Text>
          </Form.Group>
        </Card.Body>
      </Card>
    </>
  );
};

export default PriceTable;
